module.exports = "https://website-assets.prd.scentregroup.io/checkout/_next/static/media/celebrate-disney-100-with-westfield.70e548f6.png";